import Check28 from '@sats-group/icons/28/check';
import Summary from '@sats-group/fresh-fitness-ui-lib/react/summary';
import Text from '@sats-group/fresh-fitness-ui-lib/react/text';
import React from 'react';

import ContentContainer from 'root/client/components/content-container/content-container';
import SalesLayout from 'root/client/components/sales-layout/sales-layout';

import type { DropInConfirmation as Props } from './drop-in-confirmation.types';

const DropInConfirmation: React.FC<Props> = ({
  information,
  layout,
  summary,
  title,
}) => (
  <SalesLayout {...layout} theme={SalesLayout.themes.confirmation}>
    <main className="drop-in-confirmation">
      <ContentContainer width={ContentContainer.widths.Narrow}>
        <section className="drop-in-confirmation__card">
          <div className="drop-in-confirmation__title-wrapper">
            <div aria-hidden className="drop-in-confirmation__icon">
              <Check28 />
            </div>
            <Text
              className="drop-in-confirmation__title"
              theme={Text.themes.emphasis}
              size={Text.sizes.header2}
              variant={Text.variants.hero}
            >
              {title}
            </Text>
          </div>
          <div className="drop-in-confirmation__content">
            {information ? (
              <div className="drop-in-confirmation__information">
                <Text>{information}</Text>
              </div>
            ) : null}
            {summary ? (
              <Summary
                {...summary}
                type={Summary.types.standalone}
                testId="confirmation-summary"
              />
            ) : null}
          </div>
        </section>
      </ContentContainer>
    </main>
  </SalesLayout>
);

export default DropInConfirmation;
